import { FormsModule } from '@angular/forms';
import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ToggleSwitch } from 'primeng/toggleswitch';

@Component({
  selector: 'dps-toggle-card',
  standalone: true,
  imports: [FormsModule, ToggleSwitch],
  templateUrl: './toggle-card.component.html',
  styleUrl: './toggle-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-column border-1 border-round border-300 overflow-hidden',
  },
})
export class ToggleCardComponent {
  readonly title = input.required<string>();
  readonly toggled = input(false, { transform: booleanAttribute });
  readonly toggleChange = output<boolean>();
  readonly disabled = input(false);
}
